import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

export default function Navbar(props) {
  return (
    <header className={`navbar-container ${props.mode}`}>
      <nav className="navbar">
        <Link className="navbar-brand" to="/">{props.title}</Link>
        
        <div className="navbar-links">
          <Link className="nav-link" to="/Textform">Home</Link>
          <Link className="nav-link" to="/About">{props.About}</Link>
        </div>

        <div className="toggle-container">
          <label className="switch">
            <input type="checkbox" onClick={props.toggleMode} />
            <span className="slider round"></span>
          </label>
          <span className="toggle-label">Dark Mode</span>
        </div>
      </nav>
    </header>
  );
}
